export default __webpack_public_path__ + "favicons/android-chrome-384x384.png";